















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IContent, Inconsistency, InconsistencyType } from '../models';
import { CollectionNames, IAppModel } from '../services/meiosis';
import { CollectionsModel } from '../services/states/collection-state';
import TableSelectButton from './table-select-button.vue';

const findInconsistency = (fromId: string, toId: string) => (ic: Inconsistency) =>
  ic.ids.indexOf(fromId) >= 0 && ic.ids.indexOf(toId) >= 0;

@Component({
  components: { TableSelectButton },
})
export default class TableCard extends Vue {
  @Prop({ default: null }) public category!: CollectionNames | null;
  @Prop({ default: null }) public category2!: CollectionNames | null;
  @Prop({ default: () => [] }) public othercategories!: CollectionNames[];
  @Prop({ default: () => [] }) public inconsistencies!: Inconsistency[];
  public items: Partial<IContent>[] = [];
  private collections: CollectionsModel<IContent> | null = null;
  private alwaysTrue = true;

  @Watch('category')
  private categoryChanged(newCat: string) {
    console.log(`categoryChanged to ${newCat}`);
    this.init();
  }

  private otherCategoriesWithoutSelected() {
    return this.othercategories.filter(c => c !== this.category);
  }

  constructor() {
    super();
  }

  private consType(fromId: string, toId: string) {
    const found = this.inconsistencies.filter(findInconsistency(fromId, toId)).pop();
    return found ? found.type : undefined;
  }

  private changeconsistency(fromId: string, toId: string, consType: InconsistencyType) {
    // console.log({ fromId, toId, consType });
    // console.time('Change consistencies');
    if (!consType) {
      // If combination should be removed
      const indexToDelete = this.inconsistencies.findIndex(findInconsistency(fromId, toId));
      if (indexToDelete >= 0) this.inconsistencies.splice(indexToDelete, 1);
    } else {
      // If combination should not be removed
      const found = this.inconsistencies.filter(findInconsistency(fromId, toId)).pop();
      if (found) {
        // If combination already exists
        found.type = consType;
      } else {
        // If combination not exists yet
        this.inconsistencies.push({ ids: [fromId, toId], type: consType });
      }
    }
    // console.timeEnd('Change consistencies');
    this.$store.actions.updateInconsistencies(this.inconsistencies);
  }

  private async init() {
    this.$store.states.map((s: IAppModel) => {
      this.items = this.category && s[this.category] ? s[this.category].list || [] : [];
      this.collections = s;
    });
  }

  async mounted(): Promise<void> {
    console.log(`Table card mounted`);
    await this.init();
  }
}
